// src/pages/Contact.jsx

import React, { useState, useRef } from "react";
import { jsPDF } from "jspdf";
import emailjs from "emailjs-com";

function Contact() {
  const formRef = useRef();

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [type, setType] = useState("");
  const [size, setSize] = useState("");
  const [quantity, setQuantity] = useState("");
  const [details, setDetails] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("جاري إنشاء ملف PDF...");

    // إنشاء PDF
    const pdf = new jsPDF();
    pdf.setFontSize(16);
    pdf.text("طلب عرض سعر - Flexotec Maria", 10, 10);
    pdf.text(`الاسم: ${name}`, 10, 30);
    pdf.text(`رقم الجوال: ${phone}`, 10, 40);
    pdf.text(`نوع التوصيف: ${type}`, 10, 50);
    pdf.text(`القياس: ${size}`, 10, 60);
    pdf.text(`الكمية: ${quantity}`, 10, 70);
    pdf.text(`تفاصيل إضافية:`, 10, 90);
    pdf.text(details, 10, 100);

    const pdfBlob = pdf.output("blob");
    const pdfFile = new File([pdfBlob], "order.pdf", { type: "application/pdf" });

    // وضع PDF داخل input مخفي
    const pdfInput = formRef.current.querySelector("#pdfFileInput");
    const dt = new DataTransfer();
    dt.items.add(pdfFile);
    pdfInput.files = dt.files;

    setStatus("جاري إرسال الطلب...");

    emailjs
      .sendForm(
        "service_usydn2f",
        "template_8swe2f6",
        formRef.current,
        "JOkib_CxLdT9Cp2tE"
      )
      .then(() => {
        setStatus("تم إرسال الطلب بنجاح");
        setName("");
        setPhone("");
        setType("");
        setSize("");
        setQuantity("");
        setDetails("");
      })
      .catch(() => {
        setStatus("حدث خطأ أثناء الإرسال");
      });
  };

  return (
    <section id="contact" className="contact-section">
      <h2>طلب عرض سعر</h2>

      <form ref={formRef} onSubmit={handleSubmit} className="contact-form">

        {/* PDF hidden input */}
        <input type="file" id="pdfFileInput" name="pdfFile" hidden />

        <input
          type="text"
          placeholder="الاسم الكامل"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <input
          type="tel"
          placeholder="رقم الجوال"
          name="phone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />

        <select
          name="type"
          value={type}
          onChange={(e) => setType(e.target.value)}
          required
        >
          <option value="">اختر نوع التوصيف</option>
          <option value="كيس نايلون">كيس نايلون</option>
          <option value="كيس ورقي">كيس ورقي</option>
          <option value="طباعة رول">طباعة رول</option>
          <option value="طباعة ليبل">طباعة ليبل</option>
          <option value="أخرى">أخرى</option>
        </select>

        <input
          type="text"
          placeholder="القياس (مثال: 30×40 سم)"
          name="size"
          value={size}
          onChange={(e) => setSize(e.target.value)}
          required
        />

        <input
          type="number"
          placeholder="الكمية المطلوبة"
          name="quantity"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          required
        />

        <textarea
          placeholder="تفاصيل إضافية"
          name="details"
          value={details}
          onChange={(e) => setDetails(e.target.value)}
          required
        />

        <button type="submit">إرسال</button>

        {status && <p className="status">{status}</p>}
      </form>
    </section>
  );
}

export default Contact;
